"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeLazy = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var _services = require("@alycecom/services");

/**
 * Disabled to be the same like in React typings
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var safeLazy = function safeLazy(factory) {
  return /*#__PURE__*/(0, _react.lazy)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var isPageForceReloaded, component;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isPageForceReloaded = _services.sessionStorage.getItem('is_page_force_reloaded') === '1';
            _context.prev = 1;
            _context.next = 4;
            return factory();

          case 4:
            component = _context.sent;

            _services.sessionStorage.setItem('is_page_force_reloaded', '0');

            return _context.abrupt("return", component);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);

            if (isPageForceReloaded) {
              _context.next = 15;
              break;
            }

            _services.sessionStorage.setItem('is_page_force_reloaded', '1');

            window.location.reload();
            /**
             * Disabled rules because this section should not return anything due to reloading page,
             * but need to disable throwing the error.
             */
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line consistent-return

            return _context.abrupt("return");

          case 15:
            throw _context.t0;

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  })));
};

exports.safeLazy = safeLazy;